export default __webpack_public_path__ + "static/dataAgentsLP-a6bf52cc02a193c52155fa132378d3a3.png";